import { render, staticRenderFns } from "./BookingsFailed.vue?vue&type=template&id=827cb126&"
import script from "./BookingsFailed.vue?vue&type=script&lang=js&"
export * from "./BookingsFailed.vue?vue&type=script&lang=js&"
import style0 from "./BookingsFailed.vue?vue&type=style&index=0&id=827cb126&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports